import { Trash2 } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function DeletePages() {
  const { t, lang } = useLanguage();
  const tk = t.tools.deletePages;


  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/pdf/delete-pages",
    accept: ".pdf",
    multiple: false,
    resultType: "download",
    resultFileName: tk.result,
    color: "#dc2626",
    Icon: Trash2,
    toolKey: "deletePages",
    extraFields: ({ values, onChange }) => (
      <div className="p-5 bg-red-50 rounded-xl border border-red-200">
        <label className="block text-sm font-medium text-slate-700 mb-1.5">
          {tk.pagesLabel}
        </label>
        <input
          type="text"
          value={values.pages_str || ""}
          onChange={(e) => onChange({ ...values, pages_str: e.target.value })}
          placeholder={tk.pagesPlaceholder}
          data-testid="delete-pages-input"
          className="w-full px-4 py-2.5 rounded-lg border border-red-200 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500 bg-white"
        />
        <p className="text-xs text-red-600 mt-1.5 flex items-center gap-1">
          <span>⚠</span> {tk.warning}
        </p>
      </div>
    ),
  };

  return <ToolPage config={config} />;
}
